module.exports = __webpack_public_path__ + "media/images/hitfun/sample.adv.1-8e9c0eef5e1f2684ff433e1d895ecc2e.jpg";